/*global define */
/**
 * # Summary
 * Group of browser js fixes to amend some native function behaviours or set a common behaviour to them across different browsers.
 *
 * # URL encoding fixes
 * Augment encodeURIComponent() and encodeURI() functions, which should be used instead of escape() and unescape() which are deprecated and non-standard anyway.
 * escape() and unescape() are "DOM Level 0. Not part of any standard.  Mentioned in a non-normative section of ECMA-262."
 * Appropriate decoding functions are: decodeURI() and decodeURIComponent()
 * @see {@linkplain https://developer.mozilla.org/en/DOM/window.escape}
 *
 * @module libs/plugins/browserFix
 */
define(
	'browserFix',[],function () {
		window.encodeURIComponent = (function (oldFc) {
			/**
			 * Make encodeURIComponent() respect RFC 3986
			 * @see {@linkplain https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Global_Functions/encodeURIComponent}
			 * @function encodeURIComponent
			 * @param {string} str URI component to encode
			 * @return {string}
			 */
			return function () {
				return oldFc.apply(this, Array.prototype.slice.call(arguments))
					.replace(/!/g, '%21')
					.replace(/'/g, '%27')
					.replace(/\(/g, '%28')
					.replace(/\)/g, '%29')
					.replace(/\*/g, '%2A');
			};
		})(window.encodeURIComponent);
		////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
		window.encodeURI = (function (oldFc) {
			/**
			 * make encodeURI() respect IPv6
			 * @function encodeURI
			 * @see {@linkplain https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/encodeURI }
			 * @param {string} str URI to encode
			 * @return {string}
			 */
			return function () {
				return oldFc.apply(this, Array.prototype.slice.call(arguments))
					.replace(/%5B/g, '[')
					.replace(/%5D/g, ']');
			};
		})(window.encodeURI);
		////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
		window.decodeURIComponent = (function (oldFc) {
			/**
			 * Make decodeURIComponent() respect the meaning of '+' in URLs
			 * @see {@linkplain http://www.w3.org/TR/html401/interact/forms.html#form-content-type}
			 * @function decodeURIComponent
			 * @param {string} str String URI to decode
			 * @param {boolean} dontDecodePlusSign If true, the '+' signs are not replaced by ' '. (false by default)
			 * @return {string}
			 */
			return function (str, dontDecodePlusSign) {
				if (!dontDecodePlusSign) {
					str = (str + '').replace(/\+/g, ' '); // replace '+' by ' '
				}
				return oldFc.call(this, str);
			};
		})(window.decodeURIComponent);
	}
);


